import { module } from "angular";
import angularInview from "angular-inview";
import attachments from "@gtmhub/attachments/module";
import core from "@gtmhub/core/module";
import employeesCore from "@gtmhub/employees/employees-core.module";
import dndList from "@gtmhub/shared/components/dnd-list/dnd-list.module";
import { CreateTaskComponent } from "@webapp/tasks/components/create-task/create-task.component";
import { JiraIssueIconComponent } from "@webapp/tasks/components/jira-icon/jira-icon.component";
import { TasksFacade } from "@webapp/tasks/services/task-facade.service";
import { CreateKanbanTaskFormComponent } from "./components/create-kanban-task-form/create-kanban-task-form.component";
import { CreateTaskFormComponent } from "./components/create-task-form/create-task-form.component";
import { TaskCardComponent } from "./components/taks-card/task-card";
import { TaskFormComponent } from "./components/task-form.component";
import { TaskRowComponent, TaskRowCtrl } from "./components/task-row/task-row";
import { ArchivedTasksCtrl } from "./controllers/archived";
import { TaskFilterCtrl } from "./controllers/task-filter";
import { TasksCtrl } from "./controllers/tasks";
import { status } from "./filters/status.filter";
import tasksCore from "./tasks-core.module";

const mod = module("tasks", [core, tasksCore, attachments, angularInview, dndList, employeesCore]);

mod.component("taskForm", TaskFormComponent);
mod.component("createTaskForm", CreateTaskFormComponent);
mod.component("createKanbanTaskForm", CreateKanbanTaskFormComponent);
mod.component("taskRow", TaskRowComponent);
mod.component("taskCard", TaskCardComponent);

mod.controller("ArchivedTasksCtrl", ArchivedTasksCtrl);
mod.controller("TasksCtrl", TasksCtrl);
mod.controller("TaskFilterCtrl", TaskFilterCtrl);
mod.controller("TaskRowCtrl", TaskRowCtrl);

mod.downgradeComponent("jiraIssueIcon", { component: JiraIssueIconComponent, propagateDigest: false });
mod.downgradeComponent("createTask", { component: CreateTaskComponent, propagateDigest: false });
mod.downgradeInjectable("TasksFacade", TasksFacade);

mod.filter("status", status);

export default mod.name;
